/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineOrderService() {
        let orderService = {};
        orderService.getOrdersForDelivery = function (request){
            return axios.post("/api/OrderService/GetOrdersForDelivery", request);
        };
        orderService.getOrderForDelivery = function (orderId, orderDeliveryId){
            return axios.get("/api/OrderService/GetOrderForDelivery?orderId=" + orderId + "&orderDeliveryId=" + orderDeliveryId);
        };
        orderService.getCollectionOrders = function (request){
            return axios.post("/api/OrderService/GetCollectionOrders", request);
        };
        orderService.getCollectionOrder = function (orderCollectionId){
            return axios.get("/api/OrderService/GetCollectionOrder?orderCollectionId=" + orderCollectionId);
        };
        orderService.getRecentDeliveryOrders = function (request){
            return axios.post("/api/OrderService/GetRecentDeliveryOrders", request);
        };
        orderService.getRecentCollectionOrders = function (request){
            return axios.post("/api/OrderService/GetRecentCollectionOrders", request);
        };
        orderService.getSpecialPricingMethods = function (orderTypeId) {
            if(orderTypeId === orderHelper.orderType.delivery || orderTypeId === orderHelper.orderType.exTank){
                return [
                    {
                        specialPricingMethodId: orderHelper.specialPricingMethod.customerPricingPerZone,
                        description: "Customer Pricing Per Zone"
                    }
                ];
            }
            if(orderTypeId === orderHelper.orderType.collection){
                return [
                    {
                        specialPricingMethodId: orderHelper.specialPricingMethod.discountGroups,
                        description: "Discount Groups"
                    },
                    {
                        specialPricingMethodId: orderHelper.specialPricingMethod.depotDiscountGroups,
                        description: "Depot Discount Groups"
                    }
                ];
            }
        };
        orderService.getExTankOrderStatuses = function (){
            return [
                {
                    orderStatusId: orderHelper.orderStatus.pending,
                    description: "Pending"
                },
                {
                    orderStatusId: orderHelper.orderStatus.accepted,
                    description: "Accepted"
                },
                {
                    orderStatusId: orderHelper.orderStatus.rejected,
                    description: "Rejected"
                },
                {
                    orderStatusId: orderHelper.orderStatus.readyForUpliftment,
                    description: "Ready For Upliftment"
                },
                {
                    orderStatusId: orderHelper.orderStatus.uplifted,
                    description: "Uplifted"
                },
                {
                    orderStatusId: orderHelper.orderStatus.complete,
                    description: "Complete"
                },
                {
                    orderStatusId: orderHelper.orderStatus.cancelled,
                    description: "Cancelled"
                }
            ];
        };
        orderService.getCollectionOrderStatuses = function () {
            return [
                {
                    orderStatusId: orderHelper.orderStatus.accepted,
                    description: "Accepted"
                },
                {
                    orderStatusId: orderHelper.orderStatus.complete,
                    description: "Complete"
                },
                {
                    orderStatusId: orderHelper.orderStatus.pending,
                    description: "Pending"
                },
                {
                    orderStatusId: orderHelper.orderStatus.rejected,
                    description: "Rejected"
                },
                {
                    orderStatusId: orderHelper.orderStatus.readyForCollection,
                    description: "Ready For Collection"
                },
                {
                    orderStatusId: orderHelper.orderStatus.cancelled,
                    description: "Cancelled"
                }
            ];
        };
        orderService.getDeliveryOrderStatuses = function () {
            // TODO: get from api
            return [
                {
                    orderStatusId: orderHelper.orderStatus.accepted,
                    description: "Accepted"
                },
                {
                    orderStatusId: orderHelper.orderStatus.complete,
                    description: "Complete"
                },
                {
                    orderStatusId: orderHelper.orderStatus.pending,
                    description: "Pending"
                },
                {
                    orderStatusId: orderHelper.orderStatus.rejected,
                    description: "Rejected"
                },
                {
                    orderStatusId: orderHelper.orderStatus.scheduledDeliveryCancelled,
                    description: "Scheduled For Delivery Cancelled"
                },
                {
                    orderStatusId: orderHelper.orderStatus.scheduledForDelivery,
                    description: "Scheduled For Delivery"
                },
                {
                    orderStatusId: orderHelper.orderStatus.onDelivery,
                    description: "On Delivery"
                },
                {
                    orderStatusId: orderHelper.orderStatus.cancelled,
                    description: "Cancelled"
                }
            ];
        };
        orderService.getCollectionOrderStatues = function () {
            return [
                {
                    orderStatusId: orderHelper.orderStatus.readyForCollection,
                    description: "Ready For Collection"
                },
                {
                    orderStatusId: orderHelper.orderStatus.complete,
                    description: "Complete"
                },
                {
                    orderStatusId: orderHelper.orderStatus.cancelled,
                    description: "Cancelled"
                }
            ];
        };
        orderService.getOrderStatuses = function (){
            // TODO: get from api
            return [
                {
                    orderStatusId: orderHelper.orderStatus.accepted,
                    description: "Accepted"
                },
                {
                    orderStatusId: orderHelper.orderStatus.complete,
                    description: "Complete"
                },
                {
                    orderStatusId: orderHelper.orderStatus.pending,
                    description: "Pending"
                },
                {
                    orderStatusId: orderHelper.orderStatus.rejected,
                    description: "Rejected"
                },
                {
                    orderStatusId: orderHelper.orderStatus.readyForCollection,
                    description: "Ready For Collection"
                },
                {
                    orderStatusId: orderHelper.orderStatus.scheduledDeliveryCancelled,
                    description: "Scheduled For Delivery Cancelled"
                },
                {
                    orderStatusId: orderHelper.orderStatus.scheduledForDelivery,
                    description: "Scheduled For Delivery"
                },
                {
                    orderStatusId: orderHelper.orderStatus.onDelivery,
                    description: "On Delivery"
                },
                {
                    orderStatusId: orderHelper.orderStatus.cancelled,
                    description: "Cancelled"
                }
            ];
        };
        orderService.getOrderTypes = function (){
            // TODO: get from api
            return [
                {
                    orderTypeId: orderHelper.orderType.delivery,
                    description: "Delivery"
                },
                {
                    orderTypeId: orderHelper.orderType.collection,
                    description: "Collection"
                },
                {
                    orderTypeId: orderHelper.orderType.exTank,
                    description: "Ex-Tank"
                }
            ];
        };
        orderService.getProducts = function (){
            //TODO: get from api
            let products = [
                {
                    productId: 1,
                    name: "Diesel(500ppm)",
                    price: 12,
                    erpCode: "Diesel500",
                    isActive: true,
                    insertedOn: new Date(),
                    allowCollection: true,
                    allowDelivery: true,
                    discountedAmount: 0
                },
                {
                    productId: 2,
                    name: "Diesel(50ppm)",
                    price: 12,
                    erpCode: "Diesel50",
                    isActive: true,
                    insertedOn: new Date(),
                    allowCollection: false,
                    allowDelivery: true,
                    discountedAmount: 0
                }
            ];
            products = dataTableHelper.castFieldValues(products);
            return products;
        };
        orderService.addOrUpdateDeliveryOrder = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateDeliveryOrder", request);
        };
        orderService.addOrUpdateCollectionOrder = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateCollectionOrder", request);
        };
        orderService.getOrderTransactionHistoryForOrder = function (orderId){
            return axios.get("/api/OrderService/GetOrderTransactionHistoryForOrder?orderId=" + orderId);
        };
        orderService.getTrackingHistoriesForOrder = function (orderId){
            return axios.get("/api/OrderService/GetTrackingHistoriesForOrder?orderId=" + orderId);
        };
        orderService.getOrderItemsForOrder = function (orderId){
            return axios.get("/api/OrderService/GetOrderItemsForOrder?orderId=" + orderId);
        };
        orderService.cancelOrder = function (request) {
            return axios.post("/api/OrderService/CancelOrder", request);
        };
        orderService.cancelCollectionOrder = function (request) {
            return axios.post("/api/OrderService/CancelCollectionOrder", request);
        };
        orderService.cancelDeliveryOrder = function (request) {
            return axios.post("/api/OrderService/CancelDeliveryOrder", request);
        };
        orderService.getOrderDeliveryAsPdf = function (orderId, orderDeliveryId) {
            var win = window.open("/api/OrderService/GetOrderDeliveryAsPdf?orderId=" + orderId + "&orderDeliveryId=" + orderDeliveryId, "_blank");
            if (win) {
                win.focus();
            } else {
                alert('Please allow popups for this website');
            }
            //return axios.get("/api/OrderService/GetOrderDeliveryAsPdf?orderId=" + orderId + "&orderDeliveryId=" + orderDeliveryId, { responseType: "blob" });
        };
        orderService.getOrderCollectionAsPdf = function (orderId, orderCollectionId) {
            var win = window.open("/api/OrderService/GetOrderCollectionAsPdf?orderId=" + orderId + "&orderCollectionId=" + orderCollectionId, "_blank");
            if (win) {
                win.focus();
            } else {
                alert('Please allow popups for this website');
            }
            //return axios.get("/api/OrderService/GetOrderCollectionAsPdf?orderId=" + orderId + "&orderCollectionId=" + orderCollectionId, { responseType: "blob" });
        };
        orderService.getCompanyProductPricesByShippingAddress = function (request) {
            return axios.post("/api/OrderService/GetCompanyProductPricesByShippingAddress", request);
        };
        orderService.getOrderCollectionProductPricesForDepot = function (request){
            return axios.post("/api/OrderService/GetOrderCollectionProductPricesForDepot", request);
        };
        orderService.getDiscountForCompanyAndProduct = function (productId, depotId){
            var url = "/api/OrderService/GetDiscountForCompanyAndProduct?productId=" + productId;
            if(depotId !== undefined && depotId !== null){
                url += "&depotId=" + depotId;
            }
            return axios.get(url);
        };
        orderService.getOrderDispensedForOrder = function (orderId){
            return axios.get("/api/OrderService/GetOrderDispensedForOrder?orderId=" + orderId);
        };
        orderService.rescheduleOrderDeliverySchedule = function (request){
            return axios.post("/api/OrderService/RescheduleOrderDeliverySchedule", request);
        };
        orderService.getDocumentsByOrderId = function (orderId){
            return axios.get("/api/OrderService/GetDocumentsByOrderId?orderId=" + orderId);
        };
        orderService.getMonthlyBatchedDocumentsByCompanyId = function (request){
            return axios.post("/api/OrderService/GetMonthlyBatchedDocumentsByCompanyId", request);
        };
        orderService.getOrderDocument = function (request){
            return axios.post("/api/OrderService/GetOrderDocument", request, { responseType: "blob" });
        };
        orderService.getDatesForCustomerBatchedDocuments = function (startDate, endDate){
            return axios.get("/api/OrderService/GetDatesForCustomerBatchedDocuments?startDate=" + startDate + "&endDate=" + endDate);
        };
        orderService.getOrderEnquiryMessagesByOrderId = function (orderId, pageNumber, pageSize){
            return axios.get("/api/OrderService/GetOrderEnquiryMessagesByOrderId?orderId=" + orderId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize);
        };
        orderService.addOrUpdateOrderEnquiryMessage = function (request) {
            return axios.post("/api/OrderService/AddOrUpdateOrderEnquiryMessage", request);
        };
        orderService.downloadReportCollectionVolumeDispensed = function (request){
            return axios.post("/api/OrderService/DownloadReportCollectionVolumeDispensed", request, { responseType: 'blob' });
        };
        orderService.downloadReportDeliveryVarianceReport = function (request){
            return axios.post("/api/OrderService/DownloadReportDeliveryVarianceReport", request, { responseType: 'blob' });
        };
        orderService.checkReportCollectionVolumeDispensed = function (request){
            return axios.post("/api/OrderService/CheckReportCollectionVolumeDispensed", request);
        };
        orderService.checkReportDeliveryVarianceReport = function (request){
            return axios.post("/api/OrderService/CheckReportDeliveryVarianceReport", request);
        };
        orderService.downloadReportExTankDispenseVarianceReport = function (request){
            return axios.post("/api/OrderService/DownloadReportExTankDispenseVarianceReport", request, { responseType: 'blob' });
        };
        orderService.checkReportExTankDispenseVarianceReport = function (request){
            return axios.post("/api/OrderService/CheckReportExTankDispenseVarianceReport", request);
        };
        orderService.getDiscountGroups = function (request) {
            return axios.post("/api/OrderService/GetDiscountGroups", request);
        };
        orderService.getDepotDiscountGroups = function (request) {
            return axios.post("/api/OrderService/GetDepotDiscountGroups", request);
        };
        orderService.getProductsForDiscountGroup = function (discountGroupId) {
            return axios.get("/api/OrderService/GetDiscountGroupProductsByDiscountGroup?discountGroupId=" + discountGroupId);
        };
        orderService.getProductsForDepotDiscountGroup = function (depotDiscountGroupId) {
            return axios.get("/api/OrderService/GetProductsForDepotDiscountGroup?depotDiscountGroupId=" + depotDiscountGroupId);
        };
        return orderService;
    }
    //define globally if it doesn't already exist
    if (typeof (orderService) === "undefined") {
        window.orderService = defineOrderService();
    } else {
        console.log("orderService already defined.");
    }
})(window);